import api from "@/services/api";
import { toFormData } from "@/utils/ticket";

const base = "/tickets";

function ticketPath(ticketNumber, suffix = "") {
  return `${base}/${encodeURIComponent(ticketNumber)}${suffix}`;
}

export const ticketsApi = {
  async metadata() {
    const { data } = await api.get(`${base}/metadata`);
    return data.data;
  },

  async myTickets(filters = {}) {
    const { data } = await api.get("/my-tickets", { params: filters });
    return data;
  },

  async show(ticketNumber) {
    const { data } = await api.get(ticketPath(ticketNumber));
    return data.data;
  },

  async activities(ticketNumber, page = 1, itemsPerPage = 15) {
    const { data } = await api.get(ticketPath(ticketNumber, "/activities"), {
      params: { page, itemsPerPage },
    });
    return data;
  },

  async create(fields) {
    const { data } = await api.post(base, toFormData(fields), {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async reopen(ticketNumber, note) {
    const { data } = await api.post(
      ticketPath(ticketNumber, "/reopen"),
      toFormData({ note }),
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  },

  async escalate(ticketNumber, note) {
    const { data } = await api.post(
      ticketPath(ticketNumber, "/escalate"),
      toFormData({ note }),
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  },

  /*
  async close(ticketNumber, note) {
    const { data } = await api.post(
      ticketPath(ticketNumber, "/close"),
      toFormData({ note }),
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  },
  */

  async addComment(ticketNumber, fields) {
    const { data } = await api.post(
      ticketPath(ticketNumber, "/comments"),
      toFormData(fields),
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  },
};
